export const dailyBranchCollection = `http://buscrs.com/ReportCargo/DailyBranchwiseCollectionReportV3EXE?`
export const dailyBranchCollectionParams = {
  chk: 0,
  intCompanyId: 0,
  FromDate: 0,
  ToDate: 0,
  BranchId: 0,
  Summary: 0,
  BranchName: 0,
  intAllowExportToExcel: 1,
}
export const branchTransfer = `http://buscrs.com/ReportCargo/BranchTransferReportV2?`
export const branchTransferParams = {
  chk: 0,
  FromDate: '2023-03-06',
  ToDate: '2023-03-06',
  FromBranchID: '123',
  FromBranchName: 'Maven Operations Bangalore (मावेन ऑपरेशंस बेंगलुरु)',
  ToBranchID: 35067,
  ToBranchName: 'Praveen Test',
  VehicleID: 60494,
  VehicleNo: 'Auto-Dispatch.',
  intAllowExportToExcel: 1,
}
export const branchReceive = `http://buscrs.com/ReportCargo/BranchReceiptReportEXEV2?`
export const branchReceiveReceive = {
  chk: 0,
  FromDt: 0,
  ToDt: 0,
  FromBranchId: 0,
  ToBranchId: 0,
  VehicleNo: 0,
  intAllowExportExcel: 0,
}
export const userWiseCollection = `http://buscrs.com/ReportCargo/UserWiseCollectionDetiledWebReport?`
export const userWiseCollectionParams = {
  chk: 0,
  FromDt: 0,
  ToDt: 0,
  BranchID: 0,
  UserID: 0,
  Summary: 0,
  TransType: 1,
  PaymentMode: 0,
  intAllowExportToExcel: 1,
  intCargoParentCompanyID: 0,
}
export const BookingReport = `http://buscrs.com/ReportCargo/BookingReportV2Exe?`
export const BookingReportParams = {
  chk: 0,
  dtDateFrom: 0,
  dtDateTo: 0,
  intCompanyId: 0,
  intBranchId: 0,
  intpaymenttype: 0,
  intUserId: 0,
  intLoggedInUSer: 0,
  Isrefund: 0,
  intAllowViewAllReport: 0,
  companyname: '',
  intDestCityId: 0,
  strDestCityName: '',
  isSummaryOnly: 0,
  intAllowExportToExcel: 1,
}
//same for Franchisee To Own
export const BookingFranchiseeReport = `http://buscrs.com/ReportCargo/BookingFranchiseeReportV2?`
export const BookingFranchiseeReportParams = {
  chk: 0,
  dtFromDate: 0,
  dtToDate: 0,
  intCompanyID: 0,
  intBranchID: 0,
  FranchCompID: 0,
  FranchBranchID: 0,
  intpaymentType: 0,
  intUserID: 0,
  intLoggedInUser: '',
  Isrefund: 0,
  AllowViewAllReport: '',
  companyname: 0,
  intAllowExportExcel: 1,
  isSummaryOnly: 0,
}
export const quickViewReport = `http://buscrs.com/ReportCargo/QuickViewReportV3EXE?`
export const quickViewReportParams = {
  chk: 0,
  FromDate: 0,
  ToDate: 0,
  IsBranchWise: 0,
  IntCityID: 0,
  intAllowExportToExcel: 1,
}
export const partyBookingReport = `http://buscrs.com/ReportCargo/PartyBookingReportV2Exe?`
export const partyBookingReportParams = {
  chk: 0,
  FromDate: 0,
  ToDate: 0,
  CompanyId: 0,
  BranchId: 0,
  PartyAsId: 0,
  PartyId: 0,
  BookingMode: 0,
  PaymentMode: 0,
  PartyCity: 0,
  mode: 1,
  PartyName: 0,
  intAllowExportToExcel: 1,
}

export const eWayBookingReport = `http://buscrs.com/ReportCargo/EwayBillReportEXEV2?`
export const eWayBookingReportParams = {
  chk: 0,
  intCompanyId: 1,
  FromDate: 0,
  ToDate: 0,
  intFromCityId: 0,
  intToCityId: 0,
  intFromBranchId: 0,
  intToBranchId: 0,
  FromCity: 0,
  ToCity: 0,
  FromBranch: 0,
  ToBranch: 0,
  Mode: 1,
}
export const dispatchReport = `http://buscrs.com/ReportCargo/DispatchReportV3EXE?`
export const withVehicleAndCharteDate = `http://buscrs.com/ReportCargo/DispatchVehicleDateSummaryReport?`
export const dispatchReportParams = {
  chk: 0,
  mode: 'Dispatch',
  FromDate: 0,
  ToDate: 0,
  BranchId: 0,
  CommonCompanyId: 0,
  CommonUserId: 0,
  ToCityId: 0,
  VehicleNo: 0,
  CompanyName: '',
  BranchName: '',
  CityName: '',
  DBranchName: '',
  ToBranchID: 0,
  FromBranchID: 0,
  UserID: 0,
  IsSummaryHamaliReport: 0,
  IsSummaryOtherReport: 0,
  IsBranchSummaryReport: 0,
  IsVehicleDateSummaryReport: 0,
  IsVehicleDateSummaryOnlyReport: 0,
  VehicleID: 0,
  CancelledDispatchOnly: 0,
  PaymentType: 0,
  intAllowExportToExcel: 1,
}

export const challanWiseDispatch =`http://buscrs.com/ReportCargo/DispatchSummaryEXE?`
export const challanWiseDispatchParams = {
  chk : 0,
  intBranchId: 0,
  VehicleNo: 0,
  intConsignmentType: 0,
  dispatchdate:0,
  dispatchTodate:0,
  AllowViewAllReport:1,
  intAllowExportToExcel: 1,
}
export const receiveReport = `http://cargobeta.buscrs.com/ReportCargo/ReceivedReportV2?`
export const receiveReportParams = {
  chk: 0,
  CityId: 0, //default 0
  BranchId: 0,
  CompanyId: 0,
  DateFrom: `03-Apr-2023`,
  DateTo: `03-Apr-2023`,
  PaymentTypeId: 0,
  BookingMode: 0, //default 0
  PaymentType: `--All--`,
  Bookingtype: `Online And Offline booking`,
  BranchName: 0,
  IsSummaryReport: 0,
  IsAutoReceiveReport: 0,
  BookedCityId: 0,
  BookedCityName: `--All--`,
  intAllowExportToExcel: 1,
  IsBranchSummaryReport: 0,
  IsOnlyDestinationReceive: 0,
}
export const amountCreditReport = `http://buscrs.com/ReportCargo/OnAccountCreditReportV2EXE?`
export const amountCreditReportParams = {
  chk: 0,
  intSelBranchID: 0,
  strSelBranch: 0,
  intSenderPartyID: 0,
  intRecPartyID: 0,
  intSelUserID: 0,
  FromDate: 0,
  ToDate: 0,
  intAllowExportToExcel: 1,
  PartyAsId: 0,
}
// branch credit transaction
export const creditTransactionReport = `http://buscrs.com/ReportCargo/CreditLimitTransactionReportEXE?`
export const creditTransactionReportParams = {
  chk: 0,
  intBranchID: 0,
  strSelBranch: 0,
  fromdate: 0,
  todate: 0,
  intAllowExportToExcel: 1,
}
//credit Usage
export const creditUsageReport = `http://buscrs.com/ReportCargo/CreditLimitUsageReport?`
export const creditUsageReportParams = {
  chk: 0,
}
//credit summary
export const creditSummaryReport = `http://buscrs.com/ReportCargo/CreditLimitSummaryReportEXE?`
export const creditSummaryReportParams = {
  chk: 0,
  intCompanyID: 0,
  intBranchID: 0,
  intUserID: 0,
  dtfromDate: 0,
  dtToDate: 0,
  selectedBranchName: 0,
  intAllowExportToExcel: 1,
}
//gst report
export const gstReport = `http://buscrs.com/ReportCargo/GetCargoGSTV2Exe?`
export const gstReportParams = {
  chk: 0,
  dtDateFrom: 0,
  dtDateTo: 0,
  intStateId: 0,
  FromCityId: 0,
  FromBranchId: 0,
  ToCityId: 0,
  ToBranchId: 0,
  FromCity: 0,
  ToCity: 0,
  FromBranch: 0,
  ToBranch: 0,
  PaymentType: '',
  strPaymentType: '',
  GSTPaidBy: '',
  GstType: 0,
  strGstType: '',
  intAllowExportToExcel: 1,
}
export const deliveryReport = `http://buscrs.com/ReportCargo/DeliveryReportV2EXE?`
export const deliveryReportParams = {
  chk: 0,
  intCompanyID: 1,
  intBranchID: 0,
  intUserID: 0,
  dtFromDate: 0,
  dtToDate: 0,
  intPaymentType: 0,
  PaymentType: 0,
  BookedByBranch: 0,
}
export const deliveryReportFranchisee = `http://buscrs.com/ReportCargo/DeliveryFranchReportV2EXE?`
export const deliveryReportFranchiseeParams = {
  chk: 0,
  intCompanyID: 1,
  intBranchID: 0,
  intUserID: 0,
  intFranchCompanyID: 0,
  intFranchBranchID: 0,
  dtFromDate: 0,
  dtToDate: 0,
  intPaymentType: 0,
  PaymentType: 0,
  BookedByBranch: 0,
  FranchiseeCompany: 0,
  FranchiseeBranch: 0,
}
export const analysisReport = `http://buscrs.com/ReportCargo/BranchAnalysisReportExe?`
export const analysisReportParams = {
  chk: 0,
  FromDate: 0,
  ToDate: 0,
  LoginCompanyId: 0,
  LoginBranchId: 0,
  FromCityId: 0,
  FromBranchId: 0,
  ToCityId: 0,
  ToBranchId: 0,
  PaymentMode: 0,
  LoginUserId: 0,
  FromCityName: 0,
  FromBranchName: 0,
  DestCityName: 0,
  DestBranchName: 0,
  PaymentType: 0,
  IsSummary: 0,
  IsPaymentwise: 0,
  IsBookingCity: 0,
  IsBookingBranch: 0,
  IsDestCity: 0,
  IsDestBranch: 0,
  IsExtendedReport: 0,
  intAllowExportToExcel: 1,
}
export const nonMovementReport = `http://buscrs.com/ReportCargo/GetCargoNonMovedDetailsExe?`
export const nonMovementReportParams = {
  chk: 0,
  FromDate: 0,
  ToDate: 0,
  intCompanyId: 0,
  intBranchId: 0,
  intUserID: 0,
  intTimeNotMovedSince: 0,
  AllowViewAllReport: 0,
  IncludeDate: 0,
  StatusCode: `All`,
  Status: `--All--`,
  SelectBranchName: `Maven Operations Bangalore (मावेन ऑपरेशंस बेंगलुरु)`,
  intIsDays: 0,
  intDaysOrHours: 0,
  IsSummary: 0,
  IsBranchSummary: 0,
  FinYrID: 1,
  IsTranDtWise: 1,
  IsOnlyExpressParcel: 2,
  IsPaymentWise: 0,
  strPayTypeID: '',
  intAllowExportToExcel: 1,
  isV2: 4,
}

export const Reports = {
  bookingReport: 465,
  dailyBranchCollectionReport: 449,
  dispatchReport: 457,
  receiveReport: 461,
  deliveryReport: 467,
  branchTransferReport: 462,
  branchReceiveReport: 463,
  onAccountReport: 484,
  analysisReport: 90,
  nonMovementReport: 486,
  quickViewReport: 479,
  eWayBookingReport: 483,
  partyBookingReport: 485,
  userWiseCollectionReport: 472,
  bookingAndDeliveryTrackingReport: 497
}

export const branchWiseCollection = `http://buscrs.com/ReportCargo/DailyBranchwiseCollectionReportV3EXE?`
export const branchWiseCollectionParams = {
  chk: 0,
  intCompanyId: 0,
  FromDate: 0,
  ToDate: 0,
  BranchId: 0,
  Summary: 1,
  BranchName: '',
  intAllowExportToExcel: 1,
}

export const generateHisabReport = `http://buscrs.com/ReportCargo/GenerateHisabReportEXE?`
export const generateHisabReportParams = {
  chk: 0,
  FromDt: 0,
  ToDt: 0,
  VehicleNo: 0,
  VehicleID: 0,
  intAllowExportToExcel: 0,
}
export const goodsBalanceReport = `http://buscrs.com/ReportCargo/DeliveryGoodsBalanceEXE?`
export const goodsBalanceReportParams = {
  chk: 0,
  intBranchID: 0,
  fromdate: 0,
  todate: 0,
  intGoodsType: 0,
  intpaymentType: 0,
  AllowViewAllReport: 1,
  Mode: 1,
  intAllowExportToExcel: 1,
}

export const branchStockReport = `http://buscrs.com/ReportCargo/BranchStockReportEXE?`
export const branchStockReportParams = {
        chk: 0,
        SelBranchID: 0,
        DestCityID:0,
        DestBranchID: 0,
        FromDate: 0,
        ToDate: 0,
        Status:0,
        isSummaryOnly:0,
        IsOnline: -1,
        intAllowExportExcel:1
}

export const toPayDestinationReport = `http://buscrs.com/ReportCargo/ToPayDestinationReportEXE?`
export const toPayDestinationReportParams = {
  chk:0,
  intBranchID:0,
  intDestinationCityID:0,
  fromdate:0,
  todate:0,
  AllowViewAllReport:1,
  intAllowExportToExcel:1
}

export const bookingDeliveryTracking = `http://buscrs.com/ReportCargo/CargoTrackingReportEXE?`
export const bookingDeliveryTrackingParams = {
  chk: 0,
  FromDt: 0,
  ToDt: 0,
  intBranchID: 0,
  intBookingType: 0,
  intConsignmentType: 0,
  strReportMode: 'B',
  AllowViewAllReport: 1,
  strDateMode: 'B',
  intAllMovementChk: 0,
  intAllowExportExcel: 0,
  intFranchMode: 0,
  intFranchCompanyID: 0,
  intFranchBranchID: 0,
  intStateID: 0,
  intCityID: 0,
  intToCityID: 0,
  intToBranchID: 0,
  intToStateID: 0
}

export const cargoUnloadingReport = `http://buscrs.com/ReportCargo/CargoUnloaingReportEXE?`
export const cargoUnloadingParams = {
  chk: 0,
  date: 0,
  intBranchID: 0,
  VehicleNo: 0,
  AllowViewAllReport: 0,
  intAllowExportToExcel: 1,
}
//party credit transaction
export const partyCreditLimitTransactionReport = `http://buscrs.com/ReportCargo/PartyCreditLimitReportEXE?`
export const partyCreditLimitTransactionReportParams = {
  chk: 0,
  intFromCityId: 0,
  intPartyId: 0,
  FromDate: 0,
  FromCity: "",
  PartyName: "",
  Mode: 4,
  ToDate: 0,
  intAllowExportToExcel: 1,
}

export const lugguageModificationReport = `http://cargobeta.buscrs.com/ReportCargo/GetModifiedLuggageExe?`
export const lugguageModificationReportParams = {
  chk: 0,
  dtDateFrom: 0,
  dtDateTo: 0,
  FromBranchId: 0,
  FromBranch: 0,
  LRNo: 0,
  IsLRSearch: 0,
  BookingID: 0,
  intAllowExportToExcel: 0,
}
//ReceiptRegisterReport
export const ReceiptRegisterReportStationWise = `http://buscrs.com/ReportCargo/ReceiptRegisterReportEXE?`
export const ReceiptRegisterReportStationWiseParams = {
  chk: 0,
  intFromCityID:0,
  intFromBranchID:0,
  intToBranchid:1,
  intAmountType:0,
  strVehicleNo:'', 
  dtfromDate:0,
  dtToDate:0 ,
  intVehicleID:0 ,
  strFromCityName:"--All--", 
  strFromBranchName:"--All--", 
  strToBranchName:0, 
  intVehicleChk:0, 
  intAllowExportToExcel:1,
}
export const franchiseePendingToPayReport = `http://buscrs.com/ReportCargo/FranchiseeToPayPendingReportEXE?`
export const franchiseePendingToPayReportParams = {
  chk:0,
  FromDate: '',
  ToDate:'',
  BookingCityId: 0,
  BookingBranchId: 0,
  DestinationCityId: 0,
  DestinationBranchId: 0,
  intStatus: 0,
  UserId: 0,
  BookingCityName: '',
  BookingBranchName:'',
  DestinationCityName:'',
  DestinationBranchName:'',
  strStatus:'',
  intAllowExportToExcel:1
}
export const RefundReport = `http://buscrs.com/ReportCargo/RefundReportEXE?`
export const RefundReportParams = {
  chk: 0,
  intCompanyID: 0,
  intBranchID: 0,
  LoginBranchid: 0,
  intUserID: 0,
  dtfromDate: 0,
  dtToDate: 0,
  selectedBranchName: 0,
  UserName: 0,
  intAllowExportToExcel: 0,
}
export const MpesaTransactionReport = 'http://buscrs.com/AccountsReport/MpesaWalletTransactionExe?'
export const MpesaTransactionReportParams = {
  chk: 0,
  intCompanyID: 0,
  intBranchID: 0,
  dtFromDate: 0,
  dtToDate: 0,
  intAllowExportToExcel: 0,
  
}